// extracted by mini-css-extract-plugin
export default {"account_buy_add":"MultipleTopUpComp_account_buy_add__qkkoN","selected":"MultipleTopUpComp_selected__ta4by"};